import compact from 'lodash/compact';
import get from 'lodash/get';
import debounce from 'lodash/debounce';
import CustomErrorLogger from '../../helpers/CustomErrorLogger/CustomErrorLogger';

const errorTypes = {};
const ERRORS_LIMIT = 5;

/* istanbul ignore next */
export default (micrositeName, store) => {
    function logEvent(event) {
        if (!errorTypes[(event.error && event.error.message) || event.reason || event.message]) {
            errorTypes[(event.error && event.error.message) || event.reason || event.message] = 0;
        }

        // Give time for ErrorBoundary to trigger correctly
        setTimeout(() => {
            let result;
            const { pageType, pageName } = get(window.digitalData, 'page.pageInfo', {});
            if (
                event.message &&
                event.message.includes('Script error') &&
                errorTypes[event.message] <= ERRORS_LIMIT
            ) {
                result = CustomErrorLogger.triggerCustomErrorLog({
                    errorType: 'GlobalClientError',
                    errorData: { message: event.message, vendor: true },
                    errorDescription: `${window.location.pathname}: ${
                        event.message || 'Unhandled exception.'
                    }`,
                    pageType: compact([pageType, pageName]).join('-') || micrositeName,
                });
            } else if (event.reason && errorTypes[event.reason] <= ERRORS_LIMIT) {
                result = CustomErrorLogger.triggerCustomErrorLog({
                    errorType: 'PromiseRejectionError',
                    errorData: { message: event.reason },
                    errorDescription: `${window.location.pathname}: ${
                        event.reason || 'Unhandled rejection.'
                    }`,
                    pageType: compact([pageType, pageName]).join('-') || micrositeName,
                });
            } else if (
                event.error &&
                // eslint-disable-next-line no-underscore-dangle
                !event.error._boundaryAlreadyHandled &&
                errorTypes[event.error.message] <= ERRORS_LIMIT
            ) {
                result = CustomErrorLogger.triggerCustomErrorLog({
                    errorType: 'GlobalClientError',
                    errorData: event.error,
                    errorDescription: `${window.location.pathname}: ${
                        event.error.stack || 'Unhandled exception.'
                    }`,
                    pageType: compact([pageType, pageName]).join('-') || micrositeName,
                });
            } else {
                return;
            }
            store.dispatch(result);
            errorTypes[(event.error && event.error.message) || event.reason || event.message] += 1;
        }, 100);
    }

    const debounced = debounce(logEvent, 5000, { leading: true, maxWait: 10000 });

    __SERVER__ || window.addEventListener('error', debounced);
    __SERVER__ || window.addEventListener('unhandledrejection', debounced);
    __SERVER__ || window.addEventListener('rejectionhandled', debounced);
};
